import { render, staticRenderFns } from "./HomeHowItWorksTab.vue?vue&type=template&id=126a8660&scoped=true"
import script from "./HomeHowItWorksTab.vue?vue&type=script&lang=ts"
export * from "./HomeHowItWorksTab.vue?vue&type=script&lang=ts"
import style0 from "./HomeHowItWorksTab.vue?vue&type=style&index=0&id=126a8660&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126a8660",
  null
  
)

export default component.exports